module.exports = __webpack_public_path__ + "static/img/newstart_code.04215ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newstart_code.png
// module id = mReo
// module chunks = 0